import { render, staticRenderFns } from "./CallRecordsQcc.vue?vue&type=template&id=357bee9e&scoped=true&"
import script from "./CallRecordsQcc.vue?vue&type=script&lang=js&"
export * from "./CallRecordsQcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357bee9e",
  null
  
)

component.options.__file = "CallRecordsQcc.vue"
export default component.exports